import { useMemo } from "react";
import { FreeMode, Keyboard, Pagination } from "swiper/modules";

import { TabletVersion } from "../styles/ProductsStyles";
import type { ProductProps } from "./ProductsTypes";
import ProductsSwiper from "./ProductsSwiper";
import { useProductDetailsClick } from "./useProductDetailsClick";
import { useSwiperPagination } from "./useSwiperPagination";

export function ProductsTablet({
  products,
  navigate,
  navigateOut,
}: Readonly<ProductProps>) {
  const pagination = useSwiperPagination();
  const handleProductDetailsClick = useProductDetailsClick(navigate);

  const breakpoints = useMemo(
    () => ({
      0: {
        slidesPerView: 2.2,
        spaceBetween: 4,
      },
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 4,
      },
    }),
    []
  );

  return (
    <TabletVersion container>
      <ProductsSwiper
        products={products}
        navigateOut={navigateOut}
        gtmHandleClick={handleProductDetailsClick}
        freeMode
        grabCursor
        keyboard
        breakpoints={breakpoints}
        pagination={pagination}
        modules={[FreeMode, Pagination, Keyboard]}
      />
    </TabletVersion>
  );
}

export default ProductsTablet;